import React, { Component } from 'react';

//styles
import './SectionFive.scss';
import ArticlesItems from '../ArticlesItems/ArticlesItems';

class SectionFive extends Component {
    render() {
        return (
            <div id="section5" className="section5-container">
                <div className="desc-container">
                    <div className="star"></div>
                    <div className="title">שכנים, אויבים</div>
                    <div className="sub-title">טילים, חיג'אב והבזאר של ביבי: מסע לארץ האייתוללות</div>
                    <ArticlesItems action="Button_Clicked" goToArticle={this.props.goToArticle} section={6} />
                </div >
            </div >
        );
    }
}

export default SectionFive;


// WEBPACK FOOTER //
// ./src/Components/SectionFive/SectionFive.js